import { Box } from "@mui/material";
import React, { memo } from "react";
import { nodeInputStyles } from "../../GeneralNodeStyles";
import Checkbox from "../../../../../../../Components/CheckBox/Checkbox";

const TopK = memo(({ data, topk, setTopk, organization }) => {
  const { setBotData, nodeId } = data;

  const handleTopKChange = (event, type) => {
    const top_k = { ...topk };
    top_k[type] = event.target.checked;

    if (!Object.values(top_k).some((value) => value)) {
      top_k["1"] = true; // Assuming "1" is the first checkbox
    }
    setTopk({ ...top_k });
    localStorage.setItem(`topk_${nodeId}`, JSON.stringify(top_k));

    setBotData((prevData) => ({
      ...prevData,
      workflow: {
        ...prevData.workflow,
        [`${nodeId}`]: { ...prevData.workflow[`${nodeId}`], top_k: top_k },
      },
    }));
  };

  return (
    <Box
      sx={{
        ...nodeInputStyles,
        display: "flex",
        flexDirection: "column",
        gap: 1,
      }}
    >
      <div>
        <Checkbox
          label="1"
          onChange={(event) => handleTopKChange(event, "1")}
          checked={topk?.["1"]}
        />
        <Checkbox
          label="5"
          onChange={(event) => handleTopKChange(event, "5")}
          checked={topk?.["5"]}
        />
        <Checkbox
          label="10"
          onChange={(event) => handleTopKChange(event, "10")}
          checked={topk?.["10"]}
        />
        <Checkbox
          label="15"
          onChange={(event) => handleTopKChange(event, "15")}
          checked={topk?.["15"]}
          disabled={organization?.organization?.subscription === "starter"}
          tooltipText={
            organization?.organization?.subscription === "starter" &&
            "You need Pro subscription to access this feature."
          }
          tooltipPlacement="left"
        />
        <Checkbox
          label="20"
          onChange={(event) => handleTopKChange(event, "20")}
          checked={topk?.["20"]}
          disabled={organization?.organization?.subscription === "starter"}
          tooltipText={
            organization?.organization?.subscription === "starter" &&
            "You need Pro subscription to access this feature."
          }
          tooltipPlacement="left"
        />
        <Checkbox
          label="25"
          onChange={(event) => handleTopKChange(event, "25")}
          checked={topk?.["25"]}
          disabled={organization?.organization?.subscription === "starter"}
          tooltipText={
            organization?.organization?.subscription === "starter" &&
            "You need Pro subscription to access this feature."
          }
          tooltipPlacement="left"
        />
        <Checkbox
          label="30"
          onChange={(event) => handleTopKChange(event, "30")}
          checked={topk?.["30"]}
          disabled={organization?.organization?.subscription === "starter"}
          tooltipText={
            organization?.organization?.subscription === "starter" &&
            "You need Pro subscription to access this feature."
          }
          tooltipPlacement="left"
        />
        <Checkbox
          label="35"
          onChange={(event) => handleTopKChange(event, "35")}
          checked={topk?.["35"]}
          disabled={organization?.organization?.subscription === "starter"}
          tooltipText={
            organization?.organization?.subscription === "starter" &&
            "You need Pro subscription to access this feature."
          }
          tooltipPlacement="left"
        />
        <Checkbox
          label="40"
          onChange={(event) => handleTopKChange(event, "40")}
          checked={topk?.["40"]}
          disabled={organization?.organization?.subscription === "starter"}
          tooltipText={
            organization?.organization?.subscription === "starter" &&
            "You need Pro subscription to access this feature."
          }
          tooltipPlacement="left"
        />
      </div>
    </Box>
  );
});

export default TopK;
